import React, { useEffect, useState } from 'react';
import PopModal from '../../Constant/Custom/Models/PopModal';
import { BSC, CHEMICAL, CIVIL, COMPUTER, ELECTRICAL, ELECTRONICS, LEATHER, MECHANICAL, MODERNOFFICE, PRINTING, serverUrl, TEXTILE } from '../../Constant/Static/config';
import Loader from '../../Constant/Custom/Loader';
import axios from 'axios';

function Academic({ studentData, handlePrev, handleNext, gotoComment }) {
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
    const [onConfirm, setOnConfirm] = useState(() => () => { });
    const [showCancelButton, setShowCancelButton] = useState(false);
    const [onCancel, setOnCancel] = useState(() => () => { });
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const storedUser = studentData;
    const [csrfToken, setCsrfToken] = useState('');
    const [errors, setErrors] = useState({});
    const [MarkErrors, setMarkErrors] = useState({});
    const [staticData, setStaticData] = useState({
        BSC: '', CHEMICAL: '', CIVIL: '', COMPUTER: '', ELECTRICAL: '', ELECTRONICS: '', LEATHER: '', MECHANICAL: '', MODERNOFFICE: '', PRINTING: '', TEXTILE: '', DISTRICTS: '', STATES: '', AUTOCOL: '', DOTECOL: '', COLADDRESS: ''
    })

    const [studyDetailsChangedFields, setStudyDetailsChangedFields] = useState([
        { id: 1, study_detail: false, year: false, school: false, district: false, state: false },
        { id: 2, study_detail: false, year: false, school: false, district: false, state: false },
        { id: 3, study_detail: false, year: false, school: false, district: false, state: false },
        { id: 4, study_detail: false, year: false, school: false, district: false, state: false },
        { id: 5, study_detail: false, year: false, school: false, district: false, state: false },
    ])
    const [semDetailsChangedFields, setSemDetailsChangedFields] = useState({
        '1': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '2': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '3': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '4': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '5': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '6': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '7': { month: false, year: false, obtainedMarks: false, maxMarks: false },
        '8': { month: false, year: false, obtainedMarks: false, maxMarks: false },
    })
    const [changedFields, setChangedFields] = useState({
        lastTN: false,
        courseCategory: false,
        courseType: false,
        mathStudied: false,
        boardStudied: false,
        collegeName: false,
        examRegisterNo: false,
        groupName: false,
        branchName: false
    })
    const [originalData, setOriginalData] = useState({
        studyDetail: [],
        semDetail: [],
        academicDetail: {},
        courseType: ''
    });
    const [changes, setChanges] = useState(new Set());
    const changedFieldsMap = {
        lastTN: 'Last Five Years of Study in TN',
        courseCategory: 'Course category',
        courseType: 'Course type',
        mathStudied: 'Math studied',
        boardStudied: 'Board studied',
        collegeName: 'College name',
        examRegisterNo: 'ExamRegister no',
        groupName: 'Group name',
        branchName: 'Branch name'
    }
    const fetchStaticData = async () => {
        try {
            const response = await axios.get(`${serverUrl}/api/json-data`);
            setStaticData({
                BSC: response.data.bsc,
                CHEMICAL: response.data.chemical,
                CIVIL: response.data.civil,
                COMPUTER: response.data.computer,
                ELECTRICAL: response.data.electrical,
                ELECTRONICS: response.data.electronics,
                LEATHER: response.data.leather,
                MECHANICAL: response.data.mechanical,
                MODERNOFFICE: response.data.modernoffice,
                PRINTING: response.data.printing,
                TEXTILE: response.data.textile,
                DISTRICTS: response.data.districts,
                STATES: response.data.states,
                AUTOCOL: response.data["autocol-2025"],
                DOTECOL: response.data["dotecol-2025"],
                COLADDRESS: response.data.coladdress,
            });
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    const [data, setData] = useState([
        { id: 1, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 2, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 3, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 4, study_detail: '', year: '', school: '', district: '', state: '' },
        { id: 5, study_detail: '', year: '', school: '', district: '', state: '' },
    ]);

    const [studyDetailError, setStudyDetailError] = useState('');

    const handleAcademicChange = (e, index, field) => {
        const newData = data.map((item) => ({ ...item }));
        let isChanged = e.target.value !== originalData['studyDetail'][index][field];
        newData[index][field] = e.target.value;
        let isValid = true;
        if (isChanged) {
            setStudyDetailsChangedFields((prev) => prev.map((item, idx) => {
                if (idx === index)
                    return { ...item, [field]: true }
                else return item
            }))
        } else {
            setStudyDetailsChangedFields((prev) => prev.map((item, idx) => {
                if (idx === index)
                    return { ...item, [field]: false }
                else return item
            }))
        }
        for (let i = 1; i < newData.length; i++) {
            const prevYear = newData[i - 1].year ? parseInt(newData[i - 1].year) : null;
            const currentYear = newData[i].year ? parseInt(newData[i].year) : null;
            if (currentYear && prevYear && currentYear <= prevYear) {
                isValid = false;
                break;
            }
        }
        if (!isValid) {
            // console.log(AcademicFormData["lastTN"]);

            setStudyDetailsChangedFields((prev) => prev.map((item, i) => (
                (index === i || index < i) ? { ...item, study_detail: true, year: true, school: true, district: true, state: true } : item
            )))
            const resetData = newData.map((item, idx) => {
                if (idx === index || idx > index) {
                    if (AcademicFormData["lastTN"] == '1')
                        return { ...item, year: '', study_detail: '', school: '', district: '', state: 'TamilNadu' };
                    else
                        return { ...item, year: '', study_detail: '', school: '', district: 'Others', state: '' };
                }
                return item;
            });
            setData(resetData);
            setStudyDetailError(`The year in record ${index + 1} must be greater than all preceding records.`);
        } else {
            setData(newData);
            setStudyDetailError('');
        }
    };
    const validateStudyDetailForm = () => {
        const newErrors = {};
        // console.log("Study detail");

        data.forEach((item, index) => {
            if (!item.study_detail || !item.year || !item.school || !item.district || !item.state) {
                newErrors[index] = 'All fields are required';
            }
        });
        setStudyDetailError(newErrors);
        // // console.log('StudyDetail Error',newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const studyDetailsOptions = ["9th Std", "10th Std", "11th Standard", "12th Standard", "ITI 1st Year", "ITI 2nd Year", "Diploma 1st Year", "Diploma 2nd Year", "Diploma 3rd Year", "Diploma 4th Year", "B.Sc 1st Year", "B.Sc 2nd Year", "B.Sc 3rd Year"];
    let yearOptions = [];
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1960; year--) {
        yearOptions.push(year.toString());
    }
    let districtOptions = [];
    if (Array.isArray(staticData.DISTRICTS)) {
        districtOptions = staticData.DISTRICTS;
    }
    let stateOptions = [];
    if (Array.isArray(staticData.STATES)) {
        stateOptions = staticData.STATES;
    }
    let AutoCollegeOptions = [];
    if (Array.isArray(staticData.AUTOCOL)) {
        AutoCollegeOptions = staticData.AUTOCOL;
    }
    let DoteCollegeOptions = [];
    if (Array.isArray(staticData.DOTECOL)) {
        DoteCollegeOptions = staticData.DOTECOL;
    }
    const courseTypes = [
        { value: '0', label: 'Select Course Type', semesters: [] },
        { value: '6', label: 'Regular', semesters: [1, 2, 3, 4, 5, 6] },
        { value: '4', label: 'Lateral', semesters: [3, 4, 5, 6] },
        { value: '7', label: 'Sandwich (7 Semesters)', semesters: [1, 2, 3, 4, 5, 6, 7] },
        { value: '71', label: 'Sandwich (8 Semesters)', semesters: [1, 2, 3, 4, 5, 6, 7, 8] },
        { value: '72', label: 'Sandwich (Lateral - 7 Semesters)', semesters: [3, 4, 5, 6, 7] },
        { value: '73', label: 'Sandwich (Lateral - 8 Semesters)', semesters: [3, 4, 5, 6, 7, 8] },
        { value: '8', label: 'Part Time', semesters: [1, 2, 3, 4, 5, 6,7,8] }
    ];
    const monthOptions = [
        { value: '', label: 'Select Month' },
        { value: '01', label: 'January' },
        { value: '02', label: 'February' },
        { value: '03', label: 'March' },
        { value: '04', label: 'April' },
        { value: '05', label: 'May' },
        { value: '06', label: 'June' },
        { value: '07', label: 'July' },
        { value: '08', label: 'August' },
        { value: '09', label: 'September' },
        { value: '10', label: 'October' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
    ];
    const [courseType, setCourseType] = useState('');
    const [rows, setRows] = useState([]);
    const handleCourseTypeChange = (e) => {
        let name, selectedCourse;
        if (typeof e != 'string') {
            name = e.target.name;
            selectedCourse = e.target.value;
        } else {
            name = 'courseType';
            selectedCourse = '6';
        }
        setCourseType(selectedCourse);

        let isChanged = selectedCourse !== originalData[name];

        if (isChanged) {
            setChangedFields((prev) => ({ ...prev, [name]: true }))
        } else {
            setChangedFields((prev) => ({ ...prev, [name]: false }))
        }
        setCourseType(selectedCourse);
        const course = courseTypes.find(course => course.value === selectedCourse);
        if (course) {
            const semesters = course.semesters;
            const newRows = semesters.map((sem) => {
                const newRow = (rows.find(row => row.semester === sem));
                // console.log(newRow);

                if (newRow) {
                    return {
                        semester: newRow.semester,
                        month: newRow.month,
                        year: newRow.year,
                        obtainedMarks: newRow.obtainedMarks,
                        maxMarks: newRow.maxMarks
                    }
                } else {
                    return {
                        semester: sem,
                        month: '',
                        year: '',
                        obtainedMarks: 0,
                        maxMarks: 0
                    }
                }
            });
            // console.log(newRows);

            setRows(newRows)
        } else {
            setRows([]);
        }
    };
    const handleRowChange = (index, semester, field, value) => {

        if (
            field === "obtainedMarks" &&
            value !== "" &&
            !/^\d+(\.\d{0,3})?$/.test(value)
        ) {
            return;
        }

        if (
            field === "maxMarks" &&
            value !== "" &&
            !/^\d{0,4}$/.test(value)
        ) {
            return;
        }
        const newRows = rows.map((item) => ({ ...item }));
        newRows[index][field] = value;
        setRows(newRows);
        // console.log("Entered Value",newRows);


        const orgSems = originalData['semDetail'].map((item) => item.semester);
        // console.log(orgSems);

        const isChanged = !orgSems.includes(semester) || originalData['semDetail'].filter(item => item.semester === semester)?.[0]?.[field] !== value;

        setSemDetailsChangedFields((prev) => {
            if (isChanged)
                return { ...prev, [semester]: { ...prev[semester], [field]: true } }
            else
                return { ...prev, [semester]: { ...prev[semester], [field]: false } }
        })
    };
    const validateMarksForm = () => {
        const newErrors = {};
        // console.log("Valdation ");


        rows.forEach((row, index) => {
            if ((!row.month || !row.year) && !(row.obtainedMarks == 0 || row.obtainedMarks == 0)) {
                // console.log("here");

                newErrors[index] = 'All fields are required';
            }
            if ((row.obtainedMarks != 0 || row.maxMarks != 0) && parseFloat(row.obtainedMarks) > parseInt(row.maxMarks)) {
                newErrors[index] = 'Obtained marks cannot be greater than maximum marks';
            }
            // console.log(rows);
        });
        setMarkErrors(newErrors);
        // console.log(newErrors);
        // console.log(rows);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };
    const [AcademicFormData, setAcademicFormData] = useState({
        appno: storedUser?.APPLN_NO || '',
        userName: storedUser?.APPLICANT_NAME || '',
        email: storedUser?.EMAIL || '',
        mobile: storedUser?.MOBILE || '',
        lastTN: '',
        courseCategory: '',
        mathStudied: '',
        boardStudied: '',
        collegeName: '',
        collegeAddress: '',
        examRegisterNo: '',
        groupName: '',
        branchName: ''
    })
    const validateField = (name, value) => {
        let errorMessage = '';
        if (name === 'lastTN' && value.trim() === "") {
            errorMessage = 'Required';
        }
        if (name === 'courseCategory' && value.trim() === "") {
            errorMessage = 'Please select course category';
        }
        if (name === 'mathStudied' && value.trim() === "") {
            errorMessage = 'Please select mathstudied or not ';
        }
        if (name === 'boardStudied' && value.trim() === "") {
            errorMessage = 'Please select Board Studied';
        }
        if (name === 'collegeName' && value.trim() === "") {
            errorMessage = 'Please fill College Name';
        }
        if (name === 'examRegisterNo' && value.trim() === "") {
            errorMessage = 'Please Enter Exam Register Number';
        }
        if (name === 'groupName' && value.trim() === "") {
            errorMessage = 'Please select Group Name';
        }
        if (name === 'branchName' && value.trim() === "") {
            errorMessage = 'Please select Branch Name';
        }
        return errorMessage;
    };

    const isObtainedMark = (value) => {
        return /^\d+(\.\d{0,3})?$/.test(value?.toString().trim());
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let isChanged = value !== originalData['academicDetail'][name]
        let error = validateField(name, value);
        setShowCancelButton(false);

        if (isChanged) {
            setChangedFields((prev) => ({ ...prev, [name]: true }))
        } else {
            setChangedFields((prev) => ({ ...prev, [name]: false }))
        }
        if (name == "courseCategory" && value != "BSC") {
            setChangedFields((prev) => ({ ...prev, mathStudied: false }))
        }

        if (name === 'courseCategory') {
            setAcademicFormData((prev) => (
                {
                    ...prev,
                    boardStudied: ''
                }
            ))
        }

        setAcademicFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        if (name === 'mathStudied' && value === 'N') {
            setModalType({
                icon: 'error',
                title: "Eligiblity Criteria",
                text: 'Only students who have studied mathematics at Degree or +2 Level are allowed to participate in the counselling.\n12th அல்லது டிகிரி அளவில் கணிதம் படித்த மாணவர்களுக்கு மட்டுமே கலந்தாய்வில் பங்கேற்பதற்கான அனுமதி வழங்கப்படும்.'
            })
            openModal();
            setOnConfirm(() => closeModal);
            // setOnCancel(() => closeModal);
            setAcademicFormData((prev) => (
                {
                    ...prev,
                    mathStudied: 'Y'
                }
            ))
        }
        if (name === 'courseCategory' && value === "BSC") {
            setAcademicFormData((prev) => (
                {
                    ...prev,
                    mathStudied: ''
                }
            ))
            handleCourseTypeChange('6')
        }
        if (name === 'boardStudied') {
            setAcademicFormData((prevState) => ({
                ...prevState,
                collegeName: '',
                groupName: ''
            }));
            setChangedFields((prev) => ({ ...prev, ['collegeName']: true }))
        }
        if (name === 'lastTN' && value === '1') {
            const newData = [...data];
            const resetData = newData.map((item, idx) => {
                if (idx + 1) {
                    return { ...item, district: '', state: 'TamilNadu' };
                }
                return item;
            });
            setStudyDetailsChangedFields((prev) => (
                prev.map((item, idx) => (
                    { ...item, district: true, state: true }
                ))
            ))
            setData(resetData);
        }
        if (name === 'lastTN' && value === '0') {
            const newData = [...data];
            const resetData = newData.map((item, idx) => {
                if (idx + 1) {
                    return { ...item, district: 'Others', state: '' };
                }
                return item;
            });
            setStudyDetailsChangedFields((prev) => (
                prev.map((item, idx) => (
                    { ...item, district: true, state: true }
                ))
            ))
            setData(resetData);
        }
        if (name === 'groupName') {
            setAcademicFormData((prevState) => ({
                ...prevState,
                branchName: ''
            }));
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error,
        }));
    };
    const validateForm = () => {
        let isValid = true;
        const errors = {};

        if (AcademicFormData.lastTN.trim() === '') {
            errors.lastTN = "Last TN is required";
        }
        if (AcademicFormData.courseCategory.trim() === '') {
            errors.courseCategory = "Course category is required";
        }
        if (AcademicFormData.mathStudied.trim() === '' && AcademicFormData.courseCategory === "BSC") {
            errors.mathStudied = "Math studied status is required";
        }
        if (AcademicFormData.boardStudied.trim() === '') {
            errors.boardStudied = "Board studied is required";
        }
        if (AcademicFormData.collegeName.trim() === '') {
            errors.collegeName = "College name is required";
        }
        // if (AcademicFormData.collegeAddress.trim() === '') {
        //     errors.collegeAddress = "College address is required";
        // }
        if (AcademicFormData.examRegisterNo.trim() === '') {
            errors.examRegisterNo = "Exam registration number is required";
        }
        if (AcademicFormData.groupName.trim() === '') {
            errors.groupName = "Group name is required";
        }
        if (AcademicFormData.branchName.trim() === '') {
            errors.branchName = "Branch name is required";
        }
        if (Object.keys(errors).length > 0) {
            isValid = false;
        } else {
            isValid = true;
        }
        // console.log("Others");
        // console.log("Form Data:", isValid, errors);
        return isValid;
    };
    const setDefaultForm = () => {
        setData([
            { id: 1, study_detail: '', year: '', school: '', district: '', state: '' },
            { id: 2, study_detail: '', year: '', school: '', district: '', state: '' },
            { id: 3, study_detail: '', year: '', school: '', district: '', state: '' },
            { id: 4, study_detail: '', year: '', school: '', district: '', state: '' },
            { id: 5, study_detail: '', year: '', school: '', district: '', state: '' },
        ]);
        setCourseType('');
        setRows([]);
        setAcademicFormData({
            appno: storedUser?.appno || '',
            userName: storedUser?.userName || '',
            email: storedUser?.email || '',
            mobile: storedUser?.mobile || '',
            lastTN: '',
            courseCategory: '',
            mathStudied: '',
            boardStudied: '',
            collegeName: '',
            collegeAddress: '',
            examRegisterNo: '',
            groupName: '',
            branchName: ''
        });
        setOriginalData({
            studyDetail: [],
            semDetail: [],
            academicDetail: {},
            courseType: ''
        })

    };
    const setForm = (existingData) => {
        // // console.log(existingData);
        setCourseType(existingData.courseType);
        setData(existingData.studyDetails);
        setRows(existingData.semMarks);
        setAcademicFormData((prevState) => ({
            ...prevState,
            ...existingData.otherDetails
        }));
    };

    const submitDetails = async () => {
        let changesToSend = [...changes];
        // console.log(rows);

        try {
            const response = await axios.post(`${serverUrl}/api/cv/student/academic-update`, {
                studyDetails: data,
                courseType: courseType,
                semMarks: rows,
                AcademicFormData,
                changesToSend
            }, {
                headers: {
                    'CSRF-Token': csrfToken
                },
                withCredentials: true
            });
            if (response.status === 200) {
                setShowCancelButton(false);
                setModalType({
                    icon: 'success',
                    title: 'Success',
                    text: 'Academic Details are Updated Successfully.',
                });
                openModal();
                setOnConfirm(() => handleNext);
            } else {
                // console.log(response);
            }
        } catch (err) {
            console.error('Failed to store data', err);
        }
    }

    const handleAcademicDetailSubmit = async () => {
        // console.log(!validateForm() , !validateMarksForm() , !validateStudyDetailForm());

        if (!validateForm() || !validateMarksForm() || !validateStudyDetailForm()) {
            setShowCancelButton(false)
            setModalType({
                icon: 'warning',
                title: 'Warning',
                text: 'Please Fill All the Required Details',
            });
            openModal();
            setOnConfirm(() => closeModal);
            // console.log('Form is not valid');
            return;
        } else {
            let confirmationText = changes.size > 0 ? `Changed Fields :  ${[...changes].join(' | ')}` : 'No fields are changed';
            setModalType({
                title: 'Confirmation',
                icon: 'info',
                text: confirmationText
            })
            setShowCancelButton(true);
            setOnCancel(() => closeModal);
            setOnConfirm(() => submitDetails);
            openModal();
        }
    };

    // useEffect(() => {
    //     const storeSemChanges = () => {
    //         setSemDetailsChangedFields(rows.map((item) => ({
    //             semester: item.semester,
    //             month: false,
    //             year: false,
    //             obtainedMarks: false,
    //             maxMarks: false
    //         })))
    //     }
    //     storeSemChanges();

    // }, [rows])

    useEffect(() => {
        let toRemove = true;
        for (let row of studyDetailsChangedFields) {
            for (let field in row) {
                if (field != 'id' && row[field] == true) {
                    // console.log("Changes", row);
                    setChanges((prev) => new Set([...prev, 'Study Details']));
                    toRemove = false;
                    break;
                }
            }
        }

        if (toRemove) {
            // console.log("COmes");

            setChanges((prev) => new Set([...prev].filter(item => item != 'Study Details')));
        }
    }, [studyDetailsChangedFields])

    useEffect(() => {
        for (let key in changedFields) {
            if (changedFields[key]) {
                setChanges((prev) => new Set([...prev, changedFieldsMap[key]]));
            } else {
                setChanges((prev) => new Set([...prev].filter(item => item !== changedFieldsMap[key])));
            }
        }

        // console.log("Changes", changes);
    }, [changedFields])

    useEffect(() => {
        let toRemove = true;
        for (let row in semDetailsChangedFields) {
            for (let key in semDetailsChangedFields[row]) {
                if (semDetailsChangedFields[row][key] == true) {
                    setChanges((prev) => new Set([...prev, 'Semester Details']));
                    toRemove = false;
                    break;
                }
            }
        }
        // console.log("Changes", changes);
        if (toRemove) {
            setChanges((prev) => new Set([...prev].filter(item => item !== 'Semester Details')));
        }
    }, [semDetailsChangedFields])

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true, // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken); // Set CSRF token
            } catch (error) {
                console.error("Error fetching CSRF token:", error);
            }
        };

        fetchCsrfToken();
    }, []);


    useEffect(() => {
        const fetchUserData = async () => {
            if (csrfToken) {
                try {
                    const userData = studentData;
                    if (userData) {
                        const response = await axios.post(
                            `${serverUrl}/api/cv/student/academic-load`,
                            {
                                appno: userData.APPLN_NO,
                                email: userData.EMAIL,
                                mobile: userData.MOBILE,
                            },
                            {
                                headers: {
                                    'CSRF-Token': csrfToken  // Use CSRF token
                                },
                                withCredentials: true
                            }
                        );
                        // console.log(response);
                        if (response.status === 200 && response.data.courseType !== null && response.data.otherDetails.lastTN !== null) {
                            setForm(response.data);
                            setOriginalData((prev) => ({
                                ...prev,
                                courseType: response.data.courseType || '',
                                studyDetail: [...(response.data.studyDetails ?? [])],
                                semDetail: [...(response.data.semMarks ?? [])],
                                academicDetail: { ...(response.data.otherDetails ?? {}) },
                            }));
                        } else {
                            setDefaultForm();
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
        fetchStaticData();
    }, [csrfToken]);  // Dependency on csrfToken: runs when csrfToken changes

    if (loading) {
        return <Loader />;
    }

    // console.log(rows.map((item, idx) => item.semester));


    return (
        <section>
            <div className='section-head-container'>
                <h2 className='section-title'>Academic Information</h2>
                {/* <button className='log-btn button-primary' onClick={handleNext}>Save & Next</button> */}
            </div>

            <h4 className='section-sub-title'>Last Five Years of Education Details</h4>
            <div className='lastFiveYearCheck'>
                <div>
                    <h5>Have you studied in TamilNadu for the past five years ? <br />
                        <span>நீங்கள் கடந்த ஐந்து வருடங்களாக தமிழ்நாட்டில் படித்தீர்களா?</span>
                    </h5>
                </div>
                <div className="radio-group">
                    <label className="radio-container">
                        <input type="radio" name="lastTN" value="1" checked={AcademicFormData.lastTN === '1'} onChange={handleChange} /> Yes
                    </label>
                    <label className="radio-container">
                        <input type="radio" name="lastTN" value="0" checked={AcademicFormData.lastTN === '0'} onChange={handleChange} /> No
                    </label>
                </div>
            </div>

            {/* {studyDetailError && <span className="form-item-incorrect">{studyDetailError}</span>} */}
            <div className='Instruction'>
                <strong>Attention!</strong> <span>Educational details should be in order from</span> <strong>lower to higher qualification</strong><span>.</span>
            </div>
            <div className='study-table-container'>
                <table className='responsive-table'>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Study Detail</th>
                            <th>Year of Passing</th>
                            <th>School/College Name</th>
                            <th>District</th>
                            <th>State</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>
                                    <select
                                        name="study_detail"
                                        value={item?.study_detail || ""}
                                        style={{
                                            border: studyDetailsChangedFields[index].study_detail
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: studyDetailsChangedFields[index].study_detail
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}

                                        onChange={(e) => handleAcademicChange(e, index, 'study_detail')}>
                                        <option value="">--Select--</option>
                                        {studyDetailsOptions.map((option, i) => (
                                            <option key={i} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <select
                                        name="year"
                                        value={item?.year || ""}
                                        style={{
                                            border: studyDetailsChangedFields[index].year
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: studyDetailsChangedFields[index].year
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}
                                        onChange={(e) => handleAcademicChange(e, index, 'year')}
                                    >
                                        <option value="">--Select--</option>
                                        {yearOptions.map((option, i) => (
                                            <option key={i} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="school"
                                        placeholder='Enter School / College Name'
                                        style={{
                                            border: studyDetailsChangedFields[index].school
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: studyDetailsChangedFields[index].school
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}
                                        value={item?.school || ""}
                                        onChange={(e) => handleAcademicChange(e, index, 'school')}
                                    />
                                </td>
                                <td>
                                    <select
                                        name="district"
                                        value={AcademicFormData.lastTN === '0' ? 'Others' : item.district}
                                        style={{
                                            border: studyDetailsChangedFields[index].district
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: studyDetailsChangedFields[index].district
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}
                                        onChange={(e) => handleAcademicChange(e, index, 'district')}
                                        disabled={AcademicFormData.lastTN === '0'}
                                    >
                                        <option value="">--Select--</option>
                                        {AcademicFormData.lastTN === '1' ?
                                            districtOptions.map((option, i) => (
                                                <option key={i} value={option}>{option}</option>
                                            ))
                                            : <option value='Others'>Others</option>}
                                    </select>
                                </td>
                                <td>
                                    <select
                                        name="state"
                                        value={AcademicFormData.lastTN === '0' ? item.state : 'TamilNadu'}
                                        style={{
                                            border: studyDetailsChangedFields[index].state
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: studyDetailsChangedFields[index].state
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}
                                        onChange={(e) => handleAcademicChange(e, index, 'state')}
                                        disabled={AcademicFormData.lastTN === '1'}
                                    >
                                        <option value="">--Select--</option>
                                        {stateOptions.map((option, i) => (
                                            <option key={i} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </td>
                                {/* {studyDetailError[index] && (
                                    <td colSpan="6">
                                        <span className="form-item-incorrect">
                                            {studyDetailError[index]}
                                        </span>
                                    </td>
                                )} */}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='academic-detail'>
                <div>
                    <div>
                        <h5>Course Category  -  Diploma/B.Sc:<br />
                            <span>தொழில்நுட்ப பட்டயப் படிப்பு/  இளங்கலை அறிவியல்</span>
                        </h5>
                    </div>
                    <div>
                        <select
                            name="courseCategory"
                            value={AcademicFormData.courseCategory}
                            style={{
                                border: changedFields.courseCategory
                                    ? '1px solid rgb(18, 83, 162)'
                                    : 'transparent',
                                boxShadow: changedFields.courseCategory
                                    ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                    : '',
                            }}
                            onChange={handleChange}
                        >
                            <option value="">--Select--</option>
                            <option value="DIP">Diploma</option>
                            <option value="BSC">B.Sc</option>
                        </select>
                        {errors.courseCategory && <span className='form-item-incorrect'>{errors.courseCategory}</span>}
                    </div>
                </div>
                <div>
                    <div>
                        <h5>Course Type:<br />
                            <span>படிப்பு வகை</span>
                        </h5>
                    </div>
                    <div>
                        <select name="courseType" value={AcademicFormData.courseCategory === "BSC" ? '6' : courseType} disabled={AcademicFormData.courseCategory === "BSC"} style={{
                            border: changedFields.courseType
                                ? '1px solid rgb(18, 83, 162)'
                                : 'transparent',
                            boxShadow: changedFields.courseType
                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                : '',
                        }} onChange={handleCourseTypeChange}>
                            {courseTypes.map(course => (
                                <option key={course.value} value={course.value}>{course.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
                {AcademicFormData.courseCategory === "BSC" && (
                    <div>
                        <div>
                            <h5>Whether Mathematics is studied one of the Subjects in Degree Level or +2 Level? <br />
                            </h5>
                        </div>


                        <div className="radio-group">
                            <label className="radio-container">
                                <input type="radio" name="mathStudied" value="Y" style={{
                                    border: changedFields.mathStudied
                                        ? '1px solid rgb(18, 83, 162)'
                                        : 'transparent',
                                    boxShadow: changedFields.mathStudied
                                        ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                        : '',
                                }} checked={AcademicFormData.mathStudied === 'Y'} onChange={handleChange} /><span>Yes</span>
                            </label>
                            <label className="radio-container">
                                <input type="radio" name="mathStudied" value="N" style={{
                                    border: changedFields.mathStudied
                                        ? '1px solid rgb(18, 83, 162)'
                                        : 'transparent',
                                    boxShadow: changedFields.mathStudied
                                        ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                        : '',
                                }} checked={AcademicFormData.mathStudied === 'N'} onChange={handleChange} /><span>No</span>
                            </label>
                            {errors.mathStudied && <span className='form-item-incorrect'>{errors.mathStudied}</span>}
                        </div>
                    </div>
                )}
                <div>
                    <div>
                        <h5>Board of the College/ University Studied:<br />
                            <span>படித்த  கல்லூரியின்/ பல்கலைக்கழகத்தின் வாரியம்</span>
                        </h5>
                    </div>
                    <div>
                        <select
                            name="boardStudied"
                            value={AcademicFormData.boardStudied}
                            style={{
                                border: changedFields.boardStudied
                                    ? '1px solid rgb(18, 83, 162)'
                                    : 'transparent',
                                boxShadow: changedFields.boardStudied
                                    ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                    : '',
                            }}
                            onChange={handleChange}
                        >
                            <option selected value="" disabled>--Select--</option>
                            {AcademicFormData.courseCategory === "BSC" ? (
                                <>
                                    <option value="UNIVERSITY">UNIVERSITY(TN)</option>
                                    <option value="OTHERS">OTHERS</option>
                                </>
                            ) : (
                                <>
                                    <option value="DOTE">DOTE(TN)</option>
                                    <option value="AUTONOMOUS">AUTONOMOUS(TN)</option>
                                    <option value="UNIVERSITY">UNIVERSITY(TN)</option>
                                    <option value="OTHERS">OTHERS</option>
                                </>
                            )}
                        </select>
                        {errors.boardStudied && <span className='form-item-incorrect'>{errors.boardStudied}</span>}
                    </div>
                </div>
                <div>
                    <div>
                        {(AcademicFormData.boardStudied === 'UNIVERSITY' || AcademicFormData.boardStudied === 'OTHERS') ? (
                            <h5>
                                Name of the Polytechnic/ College studied with Address:<br />
                                <span>படித்த தொழில்நுட்ப கல்லூரி/ கல்லூரியின் பெயர் மற்றும் முகவரி</span>
                            </h5>
                        ) : (
                            <h5>
                                Name of the Polytechnic/ College studied:<br />
                                <span>படித்த தொழில்நுட்ப கல்லூரி/ கல்லூரியின் பெயர்</span>
                            </h5>
                        )}
                    </div>

                    <div>
                        {(AcademicFormData.boardStudied === 'UNIVERSITY' || AcademicFormData.boardStudied === 'OTHERS') ? (
                            <>
                                <input
                                    type='text'
                                    name='collegeName'
                                    placeholder='Enter College Name'
                                    value={AcademicFormData.collegeName}
                                    style={{
                                        border: changedFields.collegeName
                                            ? '1px solid rgb(18, 83, 162)'
                                            : 'transparent',
                                        boxShadow: changedFields.collegeName
                                            ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                            : '',
                                    }}
                                    onChange={handleChange}  // Ensure you have an onChange handler to update the state
                                />
                                {errors.collegeName && <span className='form-item-incorrect'>{errors.collegeName}</span>}
                            </>
                        ) : (
                            <>
                                <select
                                    name="collegeName"
                                    value={AcademicFormData.collegeName} // Controlled component
                                    style={{
                                        border: changedFields.collegeName
                                            ? '1px solid rgb(18, 83, 162)'
                                            : 'transparent',
                                        boxShadow: changedFields.collegeName
                                            ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                            : '',
                                    }}
                                    onChange={handleChange}  // Ensure the onChange handler is updating state
                                >
                                    <option value="">--Select--</option>
                                    {AcademicFormData.boardStudied === 'AUTONOMOUS' ?
                                        AutoCollegeOptions.map((option, i) => (
                                            <option key={i} value={`${option.code}-${option.name}`}>
                                                {option.code}-{option.name}
                                            </option>
                                        ))
                                        : AcademicFormData.boardStudied === 'DOTE' ?
                                            DoteCollegeOptions.map((option, i) => (
                                                <option key={i} value={`${option.code}-${option.name}`}>
                                                    {option.code}-{option.name}
                                                </option>
                                            ))
                                            : null
                                    }
                                </select>
                                {errors.collegeName && <span className='form-item-incorrect'>{errors.collegeName}</span>}
                            </>
                        )}
                    </div>

                </div>
                {/* <div>
                    <div>
                        <h5>Address of the Polytechnic/ College last studied:<br />
                            <span>படித்த தொழில்நுட்ப கல்லூரி/ கல்லூரியின் முகவரி</span>
                        </h5>
                    </div>
                    <div>
                        <input type='text'
                            name='collegeAddress'
                            value={AcademicFormData.collegeAddress}
                            onChange={handleChange}
                            placeholder='Enter Address of the College' />
                        {errors.collegeAddress && <span className='form-item-incorrect'>{errors.collegeAddress}</span>}
                    </div>
                </div> */}
                <div>
                    <div>
                        <h5>Diploma/B.Sc Examination Register Number:<br />
                            <span>தொழில்நுட்ப/ இளங்கலைப் பட்ட பதிவு எண் </span>
                        </h5>
                    </div>
                    <div>
                        <input type='text'
                            name='examRegisterNo'
                            value={AcademicFormData.examRegisterNo}
                            style={{
                                border: changedFields.examRegisterNo
                                    ? '1px solid rgb(18, 83, 162)'
                                    : 'transparent',
                                boxShadow: changedFields.examRegisterNo
                                    ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                    : '',
                            }}
                            onChange={handleChange}
                            maxLength={16}
                            placeholder='Enter Exam Register Number' />
                        {errors.examRegisterNo && <span className='form-item-incorrect'>{errors.examRegisterNo}</span>}
                    </div>
                </div>
                <div>
                    <div>
                        <h5>Group Name Studied:<br />
                            <span>படித்த துறையின் பெயர் </span>
                        </h5>
                    </div>
                    <div>
                        <select
                            name="groupName"
                            value={AcademicFormData.groupName}
                            style={{
                                border: changedFields.groupName
                                    ? '1px solid rgb(18, 83, 162)'
                                    : 'transparent',
                                boxShadow: changedFields.groupName
                                    ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                    : '',
                            }}
                            onChange={handleChange}
                        >
                            <option selected value="" disabled> --- Select Your Group --- </option>
                            {
                                AcademicFormData.courseCategory === "DIP" ? (
                                    <>
                                        <option value="1">CIVIL</option>
                                        <option value="2">MECHANICAL</option>
                                        <option value="3">ELECTRICAL</option>
                                        <option value="4">ELECTRONICS</option>
                                        <option value="5">COMPUTER</option>
                                        <option value="6">CHEMICAL</option>
                                        <option value="7">TEXTILE</option>
                                        <option value="8">LEATHER</option>
                                        <option value="9">PRINTING</option>
                                        <option value="10">DEPT. OF MODERN OFFICE PRACTICE</option>
                                        <option value="12">OTHERS</option>
                                    </>
                                ) : (
                                    <option value="11">B.Sc</option>
                                )
                            }
                        </select>
                        {errors.groupName && <span className='form-item-incorrect'>{errors.groupName}</span>}
                    </div>
                    <div>
                        <h5>Branch Name Studied:<br />
                            <span>பாடப்பிரிவின் பெயர் </span>
                        </h5>
                    </div>
                    <div>
                        {
                            AcademicFormData.groupName === '12' ? (
                                <input
                                    type="text"
                                    name="branchName"
                                    value={AcademicFormData.branchName}
                                    style={{
                                        border: changedFields.branchName
                                            ? '1px solid rgb(18, 83, 162)'
                                            : 'transparent',
                                        boxShadow: changedFields.branchName
                                            ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                            : '',
                                    }}
                                    onChange={handleChange}
                                    placeholder="Enter your branch name"
                                />
                            ) : (
                                <select
                                    name="branchName"
                                    value={AcademicFormData.branchName}
                                    style={{
                                        border: changedFields.branchName
                                            ? '1px solid rgb(18, 83, 162)'
                                            : 'transparent',
                                        boxShadow: changedFields.branchName
                                            ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                            : '',
                                    }}
                                    onChange={handleChange}
                                >
                                    <option value=""> --- Select Your Branch --- </option>
                                    {AcademicFormData.groupName === '1' && CIVIL.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '2' && MECHANICAL.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '3' && ELECTRICAL.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '4' && ELECTRONICS.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '5' && COMPUTER.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '6' && CHEMICAL.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '7' && TEXTILE.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '8' && LEATHER.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '9' && PRINTING.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '10' && MODERNOFFICE.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                    {AcademicFormData.groupName === '11' && BSC.map(item => (
                                        <option key={item.id} value={item.id}>
                                            {item.id} - {item.name}
                                        </option>
                                    ))}
                                </select>
                            )}
                        {errors.branchName && <span className='form-item-incorrect'>{errors.branchName}</span>}
                    </div>
                </div>
            </div>
            <div className='Instruction'>
                <strong>Attention!</strong> <span>Maximum mark should</span> <strong>greater than</strong><span> Obtained mark.</span>
            </div>
            <div className="marks-table-container">
                <table className="marks-responsive-table">
                    <thead>
                        <tr>
                            <th>Semester<br /><span>(பருவம்)</span></th>
                            <th>Month of Passing<br /><span>(தேர்ச்சி பெற்ற மாதம்)</span></th>
                            <th>Year of Passing<br /><span>(தேர்ச்சி பெற்ற வருடம்)</span></th>
                            <th>Obtained Marks<br /><span>(பெற்ற மதிப்பெண்)</span></th>
                            <th>Maximum Marks<br /><span>(அதிகபட்ச மதிப்பெண்)</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>{row.semester === 1 ? "1st Semester" : row.semester === 2 ? "2nd Semester" : row.semester === 3 ? "3rd Semester" : row.semester + "th Semester"}</td>
                                <td>
                                    <select
                                        name="month"
                                        value={row ? row.month : ''}
                                        style={{
                                            border: semDetailsChangedFields[row.semester].month
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: semDetailsChangedFields[row.semester].month
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}
                                        onChange={(e) => handleRowChange(index, row.semester, 'month', e.target.value)}
                                    >
                                        <option value="">--Select--</option>
                                        {monthOptions.map((option, i) => (
                                            <option key={i} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <select
                                        name="year"
                                        value={row ? row.year : ''}
                                        style={{
                                            border: semDetailsChangedFields[row.semester].year
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: semDetailsChangedFields[row.semester].year
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                        }}
                                        onChange={(e) => handleRowChange(index, row.semester, 'year', e.target.value)}
                                    >
                                        <option value="">--Select--</option>
                                        {yearOptions.map((option, i) => (
                                            <option key={i} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="obtainedMarks"
                                        pattern="^[0-9]+([0-9]+)?$"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9.]/g, '') }}
                                        value={row?.obtainedMarks}
                                        style={{
                                            border: semDetailsChangedFields[row.semester].obtainedMarks
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: semDetailsChangedFields[row.semester].obtainedMarks
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                            textAlign: 'center'
                                        }}
                                        onChange={(e) => handleRowChange(index, row.semester, 'obtainedMarks', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        name="maxMarks"
                                        pattern="^[0-9]+([0-9]+)?$"
                                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                                        value={row?.maxMarks}
                                        style={{
                                            border: semDetailsChangedFields[row.semester].maxMarks
                                                ? '1px solid rgb(18, 83, 162)'
                                                : 'transparent',
                                            boxShadow: semDetailsChangedFields[row.semester].maxMarks
                                                ? '0 0 8px 2px rgba(18, 83, 162, 0.7)'
                                                : '',
                                            textAlign: 'center'
                                        }}
                                        onChange={(e) => handleRowChange(index, row.semester, 'maxMarks', e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <br />
            <div className='next-button'>
                <button className='log-btn button button-secondary' onClick={handlePrev}>Previous</button>
                <button className='log-btn button button-primary' onClick={handleAcademicDetailSubmit}>Save & Next</button>
                <input type='submit' className='button button-primary' style={{ backgroundColor: '#218838' }} onClick={gotoComment} value='Go to Comment' />
            </div>
            <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PopModal
                    isOpen={isModalOpen}
                    type={modalType}
                    confirmButtonText="OK"
                    showCancelButton={showCancelButton}
                    cancelButtonText="Cancel"
                    onConfirm={onConfirm}
                    onCancel={onCancel}
                />
            </div>
        </section>
    )
}

export default Academic;